import { useState } from 'react'
import { useEstimation } from '@shared/hooks/estimation'
import { usePermission } from '@shared/hooks/permissions'

import Box from '@mui/material/Box'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import ListItemIcon from '@mui/material/ListItemIcon'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import TimerIcon from '@mui/icons-material/Timer'
import workTypes from '@shared/utils/workTypes'
import PushPinIcon from '@mui/icons-material/PushPin'
import IconButton from '@mui/material/IconButton'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import since from '@shared/utils/since'

// it's compatible only with InfiniteList
export default function EstimationItem({
    item,
    options,
    infiniteScroll=false
}) {
    const {
        handlePreview,
        handleEdit,
        handleDelete,
        handleExport,
        handlePin,
    } = useEstimation(item)
    const [anchor, setAnchor] = useState(null)
    const [exportAnchor, setExportAnchor] = useState(null)
    const { hasPermission } = usePermission()

    return (
        <>
            <ListItem
                disablePadding
                sx={{
                    width: '100%',
                    ...(infiniteScroll
                        ? {
                            position: 'absolute',
                            transform: `translateY(${options.start}px)`
                        } : {}
                    )
                }}
                secondaryAction={
                    <IconButton onClick={e => setAnchor(e.currentTarget)}>
                        <MoreVertIcon />
                    </IconButton>
                }
            >
                <ListItemButton onClick={item.is_draft ? handleEdit : handlePreview}>
                    {item.is_pinned &&
                        <ListItemIcon>
                            <PushPinIcon fontSize='small'/>
                        </ListItemIcon>
                    }
                    <ListItemText
                        primary={
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: .5
                            }}>
                                {item.is_draft
                                    ? <TimerIcon
                                            color='action'
                                            sx={{ fontSize: '1rem' }}
                                        />
                                    : <CheckCircleIcon
                                            color='success'
                                            sx={{ fontSize: '1rem' }}
                                        />
                                }
                                <span>{item.number}</span>
                            </Box>
                        }
                        secondary={`${workTypes[item.work_type]} ━ ${since(item.last_update)}`}
                    />
                </ListItemButton>
            </ListItem>
            <Menu
                open={!!anchor}
                onClose={() => setAnchor(null)}
                anchorEl={anchor}
            >
                {hasPermission('change_estimation') && <MenuItem onClick={() => {
                    handleEdit()
                    setAnchor(null)
                }}>تعديل</MenuItem>}
                {hasPermission('delete_estimation') && <MenuItem onClick={() => {
                    handleDelete()
                    setAnchor(null)
                }}>حذف</MenuItem>}
                <MenuItem onClick={e => setExportAnchor(e.currentTarget)}>تصدير</MenuItem>
                <MenuItem onClick={() => {
                    handlePin()
                    setAnchor(null)
                }}>{item.is_pinned ? 'إلغاء التثبيت' : 'تثبيت'}</MenuItem>
            </Menu>
            <Menu
                open={!!exportAnchor}
                onClose={() => setExportAnchor(null)}
                anchorEl={exportAnchor}
                anchorOrigin={{
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
            >
                <MenuItem
                    onClick={() => {
                        setAnchor(null)
                        setExportAnchor(null)
                        handleExport()
                    }}
                >تصدير الكل</MenuItem>
                <MenuItem
                    onClick={() => {
                        setAnchor(null)
                        setExportAnchor(null)
                        handleExport(['documents'])
                    }}
                >النماذج فقط</MenuItem>
                <MenuItem
                    onClick={() => {
                        setAnchor(null)
                        setExportAnchor(null)
                        handleExport(['location', 'violations'])
                    }}
                >الصور فقط</MenuItem>
            </Menu>
        </>
    )
}